<div *ngIf="isBlocked" class="overlay" [class.show-overlay]="isLoading" data-test="loader-isBlocked">
    <div *ngIf="isLoading" class="spinner" data-test="loader-isLoading">
        <div class="loader"></div>
    </div>
</div>
